import NewPasswordForm from 'src/components/organisms/new-password'

import { usePageTitle } from 'src/hooks'

export default function NewPassword({ title }: { title: string }) {
  usePageTitle(title)

  return <NewPasswordForm />
}
